import { render, staticRenderFns } from "./DocumentCloudItem.vue?vue&type=template&id=a6cb96d0&scoped=true&"
import script from "./DocumentCloudItem.vue?vue&type=script&lang=js&"
export * from "./DocumentCloudItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCloudItem.vue?vue&type=style&index=0&id=a6cb96d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cb96d0",
  null
  
)

export default component.exports